<template>
    <v-dialog
      v-model="showDialog"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-title>
          {{ $t('components.dialog.signout.title') }}
        </v-card-title>
        <v-card-text>
          <p class="mb-5">
          {{ $t('components.dialog.signout.confirmation') }}
          </p>

          <v-btn variant="elevated" base-color="primary" @click="confirm" class="mr-2">
            {{ $t('common.actions.confirm') }}
          </v-btn>
          <v-btn @click="close()" variant="elevated">
            {{ $t('common.actions.cancel') }}
          </v-btn>
        </v-card-text>

      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'SignoutDialog',
  components: {},
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    video() {
      return this.$store.getters['videos/selectedVideo'];
    },
  },
  methods: {
    async confirm() {
      await this.$store.dispatch('users/logout');
      await this.$store.dispatch('videos/resetState');
      await this.$store.dispatch('features/resetState');
      await this.$store.dispatch('profiles/resetState');

      this.$router.replace('/login');
    },
    close() {
      this.showDialog = false;
      this.$emit('close');
    },
  },
  props: ['show'],
  watch: {
    show(newVal) {
      this.showDialog = newVal;
    },
  },
  mounted() {
    this.showDialog = this.show;
  },
};
</script>

<style scoped>
</style>
